module.exports = __webpack_public_path__ + "img/dream_invite_self_blank.3e5f1e85.png";